import { DigisubservicesService } from './../../services/digisubservices.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EncdecriptService } from 'src/app/services/encdecrypt.service';

import { Router } from '@angular/router';
import { YearwiseAppComponent } from 'src/app/yearwise-app/yearwise-app.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  form: FormGroup;
  data1;
  hide = true;
  constructor(public fb: FormBuilder, public decryptService: EncdecriptService,
    public service: DigisubservicesService, public router: Router, private dialog: MatDialog,
  ) {
    this.form = this.fb.group({
      username: [''],
      password: ['']
    });
  }
  disableLoading = true;

  ngOnInit() { }
  ngOnDestroy() { }

  submitForm() {
    debugger
    let encrypt = this.decryptService.set('123456$#@$^@1ERF', this.form.get('password').value);
    this.disableLoading = false;

    let username = this.form.get('username').value;
    this.form.patchValue({ username: username });
    this.form.patchValue({ password: encrypt });

    let resultState = this.service.get_User(this.form.value);
    resultState.subscribe((data) => {
      this.data1 = data;

      if (this.form.value.username == this.data1.username) {
        sessionStorage.setItem("username", this.data1.username);
        sessionStorage.setItem("mobile", this.data1.mobile);
        sessionStorage.setItem("id", this.data1.id);
        sessionStorage.setItem("role", this.data1.role_id);
        sessionStorage.setItem("dept", this.data1.dept_id);

        // ✅ Call another API to fetch permissions by user_id
        this.service.getUserPermissions(this.data1.id).subscribe((permissions) => {
          // store permissions in sessionStorage
          sessionStorage.setItem("permissions", JSON.stringify(permissions));
        });

        // Open Year Selection Dialog
        const dialogRef = this.dialog.open(YearwiseAppComponent, {
          disableClose: true,
          panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe((result) => {
          debugger
          if (result && result.selectedYear) {
            sessionStorage.setItem("selectedYear", result.selectedYear);
            sessionStorage.setItem("startDate", result.startDate);
            sessionStorage.setItem("endDate", result.endDate);
            this.router.navigate(['/board/dashboard']);
          } else {
            window.alert("Year selection cancelled. Staying on login page.");
            this.form.reset();
            this.disableLoading = true;
            this.router.navigate(['/']);
          }
        });


      } else {
        this.disableLoading = true;
        window.alert("Login Failed, Please try again");
        this.router.navigate(['/']);
      }
    });
  }

}